import {useLocation, useNavigate} from "react-router-dom";
import Header from "../components/header";
import Offer from "../components/offer";
import {useEffect, useState} from "react";
import {GetPrice, Pay, TariffLogicError} from "../api/payment";
import Passengers from "../components/passengers";
import {GetVehicleCards} from "../api/cards";
import visaIcon from "../icons/visa.png"
import mastercardIcon from "../icons/mastercard.png"
import mirIcon from "../icons/mir.svg"
import busDarkIcon from "../icons/bus-dark.svg"
import checkIcon from "../icons/check.svg"
import codeIcon from "../icons/code.svg"
import Vehicle from "../components/vehicle";
import AutoPayment from "../components/autopayment"
import Loader from "../components/loader";
import pointIcon from "../icons/point.svg"
import closeIcon from "../icons/close.svg"
import attentionBigIcon from "../icons/attention-big.svg"
import {NotEnoughInformationError, VehicleBlockedError, OrderDuplicationError} from "../api/payment";

const DuplicateOrderConfirmationDialog = ({payWithIgnoreOrderDuplication, onClose}) => {
    return <div>
        <div style={{background: "#0000004D", position: "fixed", top: 0, left: 0, right: 0, bottom: 0}}></div>
        <div style={{
            background: "white",
            position: "fixed",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            left: 0,
            right: 0,
            bottom: 0,
            height: 284,
            zIndex: 9999
        }}>
            <button
                style={{
                    position: "absolute",
                    right: 16,
                    top: 16,
                    padding: 8,
                    border: 0,
                    background: "#F1F1F1",
                    borderRadius: 8
                }}>
                <img src={closeIcon} style={{display: "block"}} onClick={onClose}/>
            </button>
            <div style={{textAlign: "center", marginTop: 42}}>
                <img src={attentionBigIcon}/>
                <div style={{
                    fontSize: 22,
                    fontWeight: 600,
                    marginTop: 4,
                    letterSpacing: "-0.018em"
                }}>Заказ на этот маршрут уже есть
                    <div style={{fontSize: 14, fontWeight: 400}}>Оплатить еще один билет?</div>
                </div>
                <div style={{
                    display: "flex",
                    gap: 8,
                    paddingLeft: 16,
                    paddingRight: 16,
                    justifyContent: "center",
                    marginTop: 32
                }}>
                    <button onClick={onClose} style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: 0,
                        borderRadius: 10,
                        width: "100%",
                        height: 48,
                        color: "#1BA136",
                        background: "#1414140F"
                    }}>Нет
                    </button>
                    <button onClick={() => payWithIgnoreOrderDuplication()} style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: 0,
                        borderRadius: 10,
                        width: "100%",
                        height: 48,
                        color: "#1BA136",
                        background: "#1414140F"
                    }}>Да
                    </button>
                </div>
            </div>

        </div>
    </div>
}

const Unblocking = ({unblockCode,setUnblockCode,pay,error}) => {
    return <div style={{width: "100%"}}>
        <img alt={""} src={codeIcon} style={{width: "50%", marginTop: 56, marginBottom: 16}}/>
        <div style={{fontSize: 22, fontWeight: 500, lineHeight: "28px"}}>Проверка оплаты контролёром</div>
        <div style={{
            fontWeight: 400,
            fontSize: 15,
            lineHeight: "20px",
            letterSpacing: "-0.02em",
            color: "#898989",
            marginBottom: 8
        }}>Для завершения оплаты введите код с устройства контролёра
        </div>
        <input type={"number"}
               autoFocus
               value={unblockCode || ""}
               onChange={e => setUnblockCode(e.target.value)}
               style={{
                   width: "calc(100% - 31px)",
                   background: "#1414140F",
                   borderRadius: 12,
                   fontSize: 16,
                   paddingTop: 13,
                   paddingRight: 16,
                   paddingBottom: 15,
                   paddingLeft: 16,
                   borderWidth: 2,
                   borderStyle: "solid",
                   borderColor: error ? "#F5373C" : "silver"
               }}/>
        {error && <div style={{
            marginTop: 7,
            fontSize: 13,
            color: "#F5373C",
            marginLeft: 8,
        }}>Неверный код. Введите снова
        </div>}

        <button className={"payment-button"}
                onClick={()=>{
                    pay()
                }}
            // disabled={unblockCode?.length === 0}
                style={{position: "fixed", bottom: 16, width: "calc(100% - 31px)"}}>Оплатить
        </button>
    </div>
}

const Price = ({vehicle, cards, showCards, price, disabled, pay}) => <div style={{display: "flex", gap: 8}}>
    {!disabled && vehicle && cards.length > 0 && <div onClick={showCards} style={{
        background: "#1414140F",
        paddingTop: 8,
        borderRadius: 10,
        minWidth: 80,
        fontSize: 13
    }}>
        {cards[0].pan[0] === "4" && <img alt={"Visa"} style={{height: 12}} src={visaIcon}/>}
        {cards[0].pan[0] === "5" &&
            <img alt={"MasterCard"} style={{height: 12}} src={mastercardIcon}/>}
        {cards[0].pan[0] === "2" && <img alt={"МИР"} style={{height: 12}} src={mirIcon}/>}
        <div style={{color: "#898989"}}>····&nbsp;{cards[0].pan.slice(-4)}</div>
    </div>}
    <div style={{width: "100%"}}>
        <button className={"payment-button"} disabled={disabled} onClick={e => pay()}>
            <span>{cards.length > 0 ? "Оплатить" : "К Оплате"}</span>{price !== null ?
            <span> · {price / 100} ₽</span> : null}
        </button>
    </div>
</div>


export default ({verified}) => {
    const vehicle = useLocation().state.vehicle;
    const navigate = useNavigate()
    const [price, setPrice] = useState(null)
    const [count, setCount] = useState(1)
    const [cards, setCards] = useState(null)
    const [loading, setLoading] = useState(false)
    const [cardsLoading, setCardsLoading] = useState(false)
    const [savePayment, setSavePayment] = useState(false)
    const [showPath, setShowPath] = useState(false)
    const [fromStation, setFromStation] = useState(vehicle.station)
    const [toStation, setToStation] = useState(null)

    const [selectingFrom, setSelectingFrom] = useState(false)
    const [stationSelection, setStationSelection] = useState(null)
    const [stationSelected, setStationSelected] = useState(null)
    const [showDuplicateOrderConfirmationDialog, setShowDuplicateOrderConfirmationDialog] = useState(false)
    const [showUnblockCodeDialog, setShowUnblockCodeDialog] = useState(false)
    const [unblockCode, setUnblockCode] = useState(null)
    const [forcePay, setForcePay] = useState(false)
    const [unblockError, setUnblockError] = useState(false)

    useEffect((e) => {
        setStationSelection(null)
        getPrice()
    }, [fromStation])

    useEffect((e) => {
        setStationSelection(null)
        getPrice()
    }, [toStation])

    useEffect(() => {
        if (forcePay) {
            pay();
        } else {
            setShowDuplicateOrderConfirmationDialog(false)
        }
    }, [forcePay]);



    useEffect(() => {
        if (fromStation && toStation) {
            if (vehicle.attributes.stations.findIndex((e) => e.id === fromStation?.id) > vehicle.attributes.stations.findIndex((e) => e.id === toStation?.id)) {
                setToStation(null)
            }
        }
    }, [fromStation, toStation])

    useEffect(() => {
        getCards()
        getPrice()
    }, [])

    useEffect(() => {
        getPrice()
    }, [count])

    const getCards = () => {
        setCardsLoading(true)
        GetVehicleCards(vehicle?.id)
            .then(setCards).catch(() => {
        }).finally(() => {
            setCardsLoading(false)
        })
    }

    const getPrice = () => {
        setLoading(true)
        GetPrice(vehicle.id, fromStation.id, toStation?.id, count).then(data => {
            setPrice(data.price)
        }).catch(error => {
            if (error instanceof NotEnoughInformationError) {
                setPrice(null)
                setShowPath(true)
            }
            if (error instanceof TariffLogicError) {
                if (count > 1) {
                    setCount(count - 1)
                }
            }
        }).finally(() => {
            setLoading(false)
        })
    }
    const pay = () => {
        setLoading(true)
        Pay(vehicle.id, fromStation.id, toStation?.id, count, price, cards?.length > 0 || savePayment, forcePay, unblockCode)
            .then(data => {
                window.location.href = data.url;
            })
            .catch((error) => {
                setLoading(false)
                if (error instanceof VehicleBlockedError) {
                    setShowUnblockCodeDialog(true)
                    setUnblockError((unblockCode || "").length > 0);
                }
                if (error instanceof OrderDuplicationError) {
                    setShowDuplicateOrderConfirmationDialog(true)
                }
            })
    }

    const StationSelect = () => {
        const [search, setSearch] = useState('')
        const index = selectingFrom ? -1 : vehicle.attributes.stations.findIndex((e) => e.id === fromStation?.id);
        const [height, setHeight] = useState(window.visualViewport.height)
        useEffect(() => {
            const updateHeight = (e) => {
                setHeight(window.visualViewport.height);
            }
            window.addEventListener("resize", updateHeight)
            return () => {
                window.removeEventListener("resize", updateHeight)
            }
        }, [])
        return <>
            <div className={"vehicles"}
                 style={{paddingTop: 0, height: 62, paddingBottom: 4, marginTop: 8, marginBottom: 24}}>
                <div style={{height: 62, display: "flex", width: "100%"}}>
                    <div style={{margin: "19px 8px", marginRight: 12}}>
                        <img alt={""} src={busDarkIcon} style={{width: 24, height: 24, display: "block"}}/>
                    </div>
                    <div style={{width: "100%", height: 62, paddingTop: 10, paddingBottom: 12}}>
                        <div style={{
                            height: 20,
                            fontWeight: 400,
                            fontSize: 16,
                            color: "#141414",
                            lineHeight: "20px",
                            letterSpacing: "0.015em"
                        }}>
                            <input type={"text"} value={search} onChange={(e) => setSearch(e.target.value)}
                                   placeholder={"Поиск"}
                                   style={{border: 0, width: "100%", padding: 0}}/>
                        </div>
                        <div style={{
                            height: 18,
                            marginTop: 2,
                            fontSize: 14,
                            color: "#898989",
                            lineHeight: "18px",
                            letterSpacing: "0.02em"
                        }}>
                            {selectingFrom ? "Остановка оправления" : "Остановка прибытия"}
                        </div>
                    </div>
                </div>
            </div>
            <div className={"vehicles"} style={{overflow: "auto", height: height - 240}}>
                {vehicle.attributes.stations.filter((s) => search === '' || s.name.toUpperCase().indexOf(search.toUpperCase()) > -1).map((s, i) =>
                    <div style={{display: "flex", opacity: i <= index ? 0.3 : 1.0}}
                         onClick={i <= index ? null : () => stationSelection(s)}>
                        <div style={{margin: "19px 8px"}}>
                            <img src={pointIcon}
                                 style={{width: 24, height: 24, display: "block"}} alt={""}/>
                        </div>
                        <div style={{marginTop: 19, width: "100%"}}>{s.name}</div>
                        <div style={{marginRight: 8, marginLeft: 8, marginTop: 19, width: 24, height: 24}}>
                            {fromStation?.id === s.id || toStation?.id === s.id ?
                                <img src={checkIcon} style={{width: 24, height: 24, display: "block"}}
                                     alt={""}/> : null}
                        </div>
                    </div>
                )}
            </div>
        </>
    }



    const Approval = () => {
        return <>
            <div style={{
                fontWeight: 500,
                fontSize: 13,
                paddingLeft: 16,
                lineHeight: "16px",
                letterSpacing: "0.018em",
                color: "#898989"
            }}>Маршрут
            </div>
            <div className={"vehicles"} style={{paddingTop: 0, paddingBottom: 4, marginTop: 8, marginBottom: 24}}>
                <Vehicle vehicle={vehicle}/>
            </div>
            {
                showPath && <div>
                    <div style={{
                        fontWeight: 500,
                        fontSize: 13,
                        paddingLeft: 16,
                        lineHeight: "16px",
                        letterSpacing: "0.018em",
                        color: "#898989"
                    }}>Путь
                    </div>
                    <div className={"vehicles"}
                         style={{paddingTop: 0, paddingBottom: 4, marginTop: 8, marginBottom: 24}}>
                        <div style={{display: "flex", paddingTop: 10, paddingBottom: 10}}
                             onClick={() => {
                                 setSelectingFrom(true)
                                 setStationSelection(() => setFromStation)
                                 setStationSelected(fromStation)
                             }}>
                            <div style={{paddingLeft: 8, paddingTop: 8}}>
                                <img src={busDarkIcon} alt={""} style={{width: 24, height: 24, display: "block"}}/>
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    marginRight: 8,
                                    paddingLeft: 12,
                                }}>
                                <div style={{display: "flex"}}>
                                    <div style={{width: "100%"}}>
                                        <div style={{
                                            fontWeight: 400,
                                            fontSize: 16,
                                            color: "#141414",
                                            lineHeight: "20px",
                                            letterSpacing: "0.015em"
                                        }}>
                                            {fromStation ? fromStation.name : "Отправление"}
                                        </div>
                                        <div style={{
                                            marginTop: 2,
                                            fontSize: 14,
                                            color: "#898989",
                                            lineHeight: "18px",
                                            letterSpacing: "0.02em"
                                        }}>
                                            {fromStation ? "Остановка оправления" : "Выберите остановку"}
                                        </div>
                                    </div>
                                    <div style={{paddingTop: 8}}>
                                        {fromStation ?
                                            <img src={checkIcon} style={{width: 24, height: 24, display: "block"}}/> :
                                            <span style={{
                                                color: "#1BA136",
                                                fontWeight: 500,
                                                letterSpacing: "-0.015em",
                                                fontSize: 16
                                            }}>Выбрать</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr style={{
                            marginLeft: 32,
                            marginRight: 8,
                            marginTop: 0,
                            marginBottom: 0,
                            height: 0,
                            border: 0,
                            borderBottom: "0.5px solid #8989894D",
                        }}/>
                        <div style={{display: "flex", paddingTop: 10, paddingBottom: 10}}
                             onClick={() => {
                                 setSelectingFrom(false)
                                 setStationSelection(() => setToStation)
                                 setStationSelected(toStation)
                             }}>
                            <div style={{paddingLeft: 8, paddingTop: 8}}>
                                <img alt={""} src={busDarkIcon} style={{width: 24, height: 24, display: "block"}}/>
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    marginRight: 8,
                                    paddingLeft: 12,
                                }}>
                                <div style={{display: "flex"}}>
                                    <div style={{width: "100%"}}>
                                        <div style={{
                                            fontWeight: 400,
                                            fontSize: 16,
                                            color: "#141414",
                                            lineHeight: "20px",
                                            letterSpacing: "0.015em"
                                        }}>
                                            {toStation ? toStation.name : "Прибытие"}
                                        </div>
                                        <div style={{
                                            marginTop: 2,
                                            fontSize: 14,
                                            color: "#898989",
                                            lineHeight: "18px",
                                            letterSpacing: "0.02em"
                                        }}>
                                            {toStation ? "Остановка прибытия" : "Выберите остановку"}
                                        </div>
                                    </div>
                                    <div style={{paddingTop: 8}}>
                                        {toStation ?
                                            <img src={checkIcon} alt={""}
                                                 style={{width: 24, height: 24, display: "block"}}/> :
                                            <span style={{
                                                color: "#1BA136",
                                                fontWeight: 500,
                                                letterSpacing: "-0.015em",
                                                fontSize: 16
                                            }}>Выбрать</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                ((verified && cards && cards.length === 0) || !verified) &&
                <AutoPayment savePayment={savePayment} verified={verified} setSavePayment={setSavePayment}/>
            }
            <div className={"payment"}>
                <Passengers count={count} setCount={setCount}/>
                <Price
                    vehicle={vehicle}
                    showCards={() => navigate("/cards")}
                    price={price}
                    cards={cards || []}
                    pay={pay}
                    disabled={price == null || loading || cardsLoading}/>
                <Offer/>
            </div>
        </>
    }

    return <div className={"page"}>
        <Loader
            visible={loading || cardsLoading}
        />
        <Header title={"Оплатить проезд"} onBack={stationSelection ? () => setStationSelection(null) : showUnblockCodeDialog ? ()=>setShowUnblockCodeDialog(false) : null}/>
        {!loading && showDuplicateOrderConfirmationDialog &&
            <DuplicateOrderConfirmationDialog payWithIgnoreOrderDuplication={() => {
                setForcePay(true)
            }}
                                              onClose={() => {
                                                  setForcePay(false)
                                              }}/>}
        {stationSelection ? <StationSelect/> : showUnblockCodeDialog ? <Unblocking pay={pay} setUnblockCode={setUnblockCode} unblockCode={unblockCode} error={unblockError}/> : <Approval/>}
    </div>
}
